import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import ReportBuilderPage from './ReportBuilderPage';
import ReportsManagement from './ReportsManagement';
import { Settings, FolderOpen } from 'lucide-react';

function UnifiedReportBuilderPage() {
  const [activeTab, setActiveTab] = useState('builder');

  return (
    <div className="w-full space-y-5">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Report Builder</h1>
        <p className="text-sm text-gray-500 mt-0.5">Build custom reports and manage merchant reports</p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="builder" className="flex items-center gap-2">
            <Settings className="w-4 h-4" />
            <span>Build Reports</span>
          </TabsTrigger>
          <TabsTrigger value="management" className="flex items-center gap-2">
            <FolderOpen className="w-4 h-4" />
            <span>Reports Management</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="builder" className="mt-6">
          <ReportBuilderPage />
        </TabsContent>

        <TabsContent value="management" className="mt-6">
          <ReportsManagement />
        </TabsContent>
      </Tabs>
    </div>
  );
}

export default UnifiedReportBuilderPage;
